import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'ModalTemplate',
  props: ['config', 'currentStep'],
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const randKey = computed(() => {
  return (Math.random() + 1).toString(36).substring(7);
})

const totalSteps = computed(() => {
  const n = Number(props.config?.steps) || 1;
  return n > 0 ? n : 1;
});

const showStepIndicator = computed(() => {
  return !!props.config?.show_step_indicator && totalSteps.value > 1;
});

const stepLabels = computed(() => {
  const titles: string[] = Array.isArray(props.config?.step_titles) ? props.config.step_titles : [];
  const out: string[] = [];
  for (let i = 0; i < totalSteps.value; i++) {
    const t = (titles[i] ?? '').toString().trim();
    out.push(t !== '' ? t : `Step ${i + 1}`);
  }
  return out;
});

const activeStep = computed(() => {
  const current = Number(props.currentStep) || 1;
  return Math.max(0, current - 1);
});

const __returned__ = { props, randKey, totalSteps, showStepIndicator, stepLabels, activeStep }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})